import SettingsWrapper from 'app/components/Layout/SettingsWrapper';
import adminSettingsSubNavigationLinks from 'app/pages/Admin/_components/AdminPageWrapper/_config/adminSettingsSubNavigationLinks';

const AdminPageWrapper = () => {
  return <SettingsWrapper menuItems={adminSettingsSubNavigationLinks} />;
};

export default AdminPageWrapper;
